const baseURL = 'https://danivergustof.komerzy.com/';

export default baseURL;